import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { AppProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';
import ContactOrganizerButton from './ContactOrganizerButton';
export interface ContactOrganizerProps {
    organizerId: string;
    organizerName?: string;
    isVisible: boolean;
    captchaKey: string;
    onClose?: Function;
    isAuthenticated?: boolean;
    domNodeId?: string;
    domNode?: Element;
    eventName: string;
    eventId: string; // Property required to render ContactOrganizer from Listings
}

const getContactOrganizerProps = (props: AppProps): ContactOrganizerProps => {
    const {
        user: { isAuthenticated },
        organizer: { id: organizerId, name: organizerName },
        components: {
            contactOrganizer: { captchaKey },
        },
        event: { name: eventName, id: eventId },
    } = props;

    return {
        organizerId,
        organizerName,
        captchaKey,
        isVisible: false,
        isAuthenticated,
        eventName,
        eventId,
    };
};

const CONTACT_ORGANIZER_ORG_PANEL_ID =
    'listings-root__contact-organizer_org-panel';

const ContactOrganizerMount = (props: ContactOrganizerProps) =>
    dynaMount(
        {
            Component: ContactOrganizerButton,
            containerId: CONTACT_ORGANIZER_ORG_PANEL_ID,
        },
        props,
    );

const ContactOrganizerRoot = (props: AppProps): JSX.Element | null => {
    if (isEmpty(props.organizer)) {
        return null;
    }
    const contactOrganizerProps = getContactOrganizerProps(props);
    return <ContactOrganizerMount {...contactOrganizerProps} />;
};

export default ContactOrganizerRoot;
